import { defineStore } from 'pinia'
import { toRaw } from "vue";

export const useReportStore = defineStore('report', {
    state: () => {
        return {
            form: {
                dimension: [],
                dimensionOption: [],
                metric: { "column": [ "quarter" ], "granularity": "monthly" },
                filter: [ { where: 'Field', condition: 'Condition', value: [] } ]
            }
        }
    },
    getters: {
        getDimensions: state => state.form.dimension,
        getMetrics: state => state.form.metric,
        getFilters: state => state.form.filter,
        getForm: state => state.form,
    },
    actions: {
        setDimensions(payload) {
            this.form.dimension = payload
        },
        setDimensionOption(payload) {
            this.form.dimensionOption = payload
        },
        setMetrics(payload) {
            let arrSort = toRaw(payload)
            if (arrSort.column?.indexOf('cumulative')) {
                arrSort.column?.splice(arrSort.column?.length, 0, arrSort.column?.splice(arrSort.column.indexOf('cumulative'), 1)[0]);
            }
            this.form.metric = toRaw(arrSort);
        },
        setFilters(payload) {
            this.form.filter = payload
        },
    }
})
